import { useQuery } from '@apollo/client';
import React, { useLayoutEffect, useMemo } from 'react';
import type { Op } from 'quill/core';
import SideColumnLayout from '../components/SideColumnLayout';
import ReferralModal from '../user/ReferralModal';
import { openPricingModal } from '../utils/url/pricingPath';
import HomeActivities from './HomeActivities';
import OrganizationSummary from './organizationSummary/OrganizationSummary';
import useViewedPostsColumn from './useViewedPostsColumn';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { gql } from '../graphql/generated/gql';
import { UIActions } from '../ui/uiSlice';

const ORGANIZATION_SUMMARY_QUERY = gql(`
  query organizationSummary {
    session: currentSession {
      organization {
        id
        summary
      }
    }
  }
`);

type HomeModal = 'pricing' | 'referral';

interface HomeViewProps {
  openModal?: HomeModal;
}

const useModal = (modal?: HomeModal) => {
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    if (modal === 'pricing') {
      openPricingModal(dispatch);
    } else if (modal === 'referral') {
      dispatch(UIActions.openModal(ReferralModal));
    } else {
      return undefined;
    }

    return () => {
      dispatch(UIActions.closeModal());
    };
  }, [dispatch, modal]);
};

const HomeView = ({ openModal }: HomeViewProps) => {
  const { data, loading } = useQuery(ORGANIZATION_SUMMARY_QUERY);
  const organization = data?.session?.organization;
  const summary = useMemo(() => {
    if (organization?.summary) {
      return JSON.parse(organization.summary) as Op[];
    }
    return null;
  }, [organization]);
  const main = useViewedPostsColumn();
  useModal(openModal);

  return (
    <div id="content" className="no-padding-x no-padding-y">
      <SideColumnLayout
        aboveMain={<OrganizationSummary summary={summary} />}
        main={loading && !summary ? undefined : main}
        sideColumn={{
          title: 'Activity',
          children: <HomeActivities />,
        }}
      />
    </div>
  );
};

export default HomeView;
